<!--
  -  Copyright (C) Healabs 2022 - All Rights Reserved
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -
  -->

<template>
  <loader v-if="loading" />
  <v-container v-else-if="decommissioned" fluid class="fill-height">
    <v-row justify="center" align="center" no-gutters>
      <v-col cols="12" sm="9" md="7" lg="5">
        <v-card flat class="elevation-x pa-6 text-center">
          <v-img :src="require('@/assets/img/maPread_logo_color.svg')" max-width="220px" contain
                 class="mx-auto mb-6"
          />
          <font-awesome-icon :icon="['fad', 'exclamation-triangle']" size="3x" class="orange--text mb-5" />
          <h1 class="text-h5 font-alt mb-4">La plateforme maPread n'est plus accessible</h1>
          <p class="font-alt font-weight-light mb-2">
            La plateforme de préadmission maPread n'est plus accessible pour votre établissement.
          </p>
          <p class="font-alt font-weight-light mb-0">
            Nous vous invitons à vous rapprocher directement de votre clinique pour toute
            information concernant votre admission.
          </p>
          <v-btn color="primary" class="mt-6" @click="logout">Se déconnecter</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <router-view v-else />
</template>

<script>
  import Loader from '@/modules/core/components/Loader'
  import * as stays from '@/modules/stays/api'

  // Établissements décommissionnés : les patients qui y sont rattachés ne peuvent plus
  // accéder à la plateforme et voient un message d'information à la place.
  const DECOMMISSIONED_ESTABLISHMENT_IDS = [
    '1ec5213d-9158-63e4-9fa4-0744ba2b4582' // Clinique Charcot
  ]

  export default {
    name: 'PatientSection',
    components: {Loader},
    data() {
      return {
        loading: true,
        decommissioned: false
      }
    },
    async created() {
      try {
        const patientStays = (await stays.list({params: {itemsPerPage: 200}})).data['hydra:member']
        this.decommissioned = patientStays.some(stay => {
          const establishment = stay.service && stay.service.establishment
          if (!establishment) {
            return false
          }
          const iri = establishment['@id'] || ''
          return DECOMMISSIONED_ESTABLISHMENT_IDS.some(id => iri.includes(id) || establishment.id === id)
        })
      } catch (error) {
        this.$root.$emit('error', error)
      } finally {
        this.loading = false
      }
    },
    methods: {
      logout() {
        this.$auth.logout()
      }
    }
  }
</script>
